var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 5.83464H10.8334V7.5013H9.16675V5.83464ZM9.16675 9.16797H10.8334V14.168H9.16675V9.16797ZM10.0001 1.66797C5.40008 1.66797 1.66675 5.4013 1.66675 10.0013C1.66675 14.6013 5.40008 18.3346 10.0001 18.3346C14.6001 18.3346 18.3334 14.6013 18.3334 10.0013C18.3334 5.4013 14.6001 1.66797 10.0001 1.66797ZM10.0001 16.668C6.32508 16.668 3.33341 13.6763 3.33341 10.0013C3.33341 6.3263 6.32508 3.33464 10.0001 3.33464C13.6751 3.33464 16.6667 6.3263 16.6667 10.0013C16.6667 13.6763 13.6751 16.668 10.0001 16.668Z",
    fill: "#B01BAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ff3b23228eb0ef12ca013d8147cd741e.svg";
export { ForwardRef as ReactComponent };